module.exports = "/fonts/fa-regular-400.woff?f3dd4f397fbc5aaf831b6b0ba112d75c";